import React, { useRef, useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
interface OutsideAlerterProps {
    children: React.ReactNode;
    closeWindow: () => void;
    className?: string;
}
function useOutsideAlerter(ref, closeWindow: any) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target) && closeWindow) {
                closeWindow()
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

/**
 * Component that alerts if you click outside of it
 */
export default function OutsideAlerter(props: OutsideAlerterProps) {
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, props.closeWindow);

    return <div className={props.className} ref={wrapperRef}>{props.children}</div>;
}